import {
	TIMELINE_SEARCH_UPDATE_DOCUMENT_PRIORITY,
	TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE,
	TIMELINE_SET_SOURCE_FILTER,
	TIMELINE_RESULTS_CLEAR,
	UPDATE_TIMELINE_METADATA,
	GET_TIMELINE_SEARCH_REQUEST,
	GET_TIMELINE_SEARCH_REQUEST_FAILED,
	GET_TIMELINE_SEARCH_REQUEST_CLEAR,
	GET_GRAPH_DATA_REQUEST,
	GET_GRAPH_DATA_REQUEST_SUCCESS,
	GET_GRAPH_DATA_REQUEST_FAILED,
	GET_GRAPH_DATA_REQUEST_CLEAR,
	GET_SAVED_DATE_RANGE,
	GET_SAVED_DATE_RANGE_SUCCESS,
	GET_SAVED_DATE_RANGE_FAIL,
	GET_SAVED_DATE_RANGE_CLEAR,
	POST_SAVED_DATE_RANGE,
	POST_SAVED_DATE_RANGE_SUCCESS,
	POST_SAVED_DATE_RANGE_FAIL,
	POST_SAVED_DATE_RANGE_CLEAR,
	DELETE_SAVED_DATE_RANGE,
	DELETE_SAVED_DATE_RANGE_SUCCESS,
	DELETE_SAVED_DATE_RANGE_FAIL,
	GET_SAVED_DATE_RANGE_NAME_CHECK,
	GET_SAVED_DATE_RANGE_NAME_CHECK_SUCCESS,
	GET_SAVED_DATE_RANGE_NAME_CHECK_FAIL,
} from "../types"

export const clearTimelineRequest = () => ({
	type: TIMELINE_RESULTS_CLEAR,
})

export const updateDocumentTimelimePriority = (document_id, priority) => ({
	type: TIMELINE_SEARCH_UPDATE_DOCUMENT_PRIORITY,
	payload: { id: document_id, priority: priority },
})

export const updateDocumentTimelimeDate = (document_id, newdate) => ({
	type: TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE,
	payload: { id: document_id, date: newdate },
})

export const callClearTimelimeConceptTargetTerms = (value) => ({
	type: TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	payload: value,
})

export const callUpdateTimelimeConceptTargetTerms = (terms) => ({
	type: TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
	payload: terms,
})

export const setCurrentSourceFilter = (filter) => ({
	type: TIMELINE_SET_SOURCE_FILTER,
	payload: filter,
})

//update timeline metadata
export const updateTimelineMetadata = (data) => ({
	type: UPDATE_TIMELINE_METADATA,
	payload: data,
})

export const getTimeLineSearchData = (
	searchObject,
	filter = [""],
	categories = [""],
	cancelToken = null,
	pageSize = 0,
	skipCount = 0,
	sort = {},
	filters = {},
	page_context = "",
	skip_audit = false,
	jobIdToRetainData = null,
	selecteGraphdDateRange = {},
	restrict_file_ids = [],
	review_id = "",
	is_case_admin = false
) => ({
	type: GET_TIMELINE_SEARCH_REQUEST,
	payload: {
		searchObject: searchObject,
		filter: filter,
		categories: categories,
		cancelToken: cancelToken,
		pageSize: pageSize,
		skipCount: skipCount,
		sort: sort,
		filters: filters,
		page_context,
		skip_audit,
		jobIdToRetainData,
		selecteGraphdDateRange,
		restrict_file_ids,
		review_id,
		is_case_admin,
	},
})

export const getTimeLineSearchDataFailed = (data) => ({
	type: GET_TIMELINE_SEARCH_REQUEST_FAILED,
	payload: data,
})

export const getTimeLineSearchDataClear = () => ({
	type: GET_TIMELINE_SEARCH_REQUEST_CLEAR,
})

export const getGraphDataRequest = (data) => ({
	type: GET_GRAPH_DATA_REQUEST,
	payload: data,
})

export const getGraphDataRequestSuccess = (data) => ({
	type: GET_GRAPH_DATA_REQUEST_SUCCESS,
	payload: data,
})

export const getGraphDataRequestFailed = (data) => ({
	type: GET_GRAPH_DATA_REQUEST_FAILED,
	payload: data,
})

export const getGraphDataRequestClear = () => ({
	type: GET_GRAPH_DATA_REQUEST_CLEAR,
})

export const getSavedDateRange = (data) => ({
	type: GET_SAVED_DATE_RANGE,
	payload: data,
})

export const getSavedDateRangeSuccess = (data) => ({
	type: GET_SAVED_DATE_RANGE_SUCCESS,
	payload: data,
})

export const getSavedDateRangeFailed = (data) => ({
	type: GET_SAVED_DATE_RANGE_FAIL,
	payload: data,
})

export const getSavedDateRangeClear = () => ({
	type: GET_SAVED_DATE_RANGE_CLEAR,
})

export const postSavedDateRange = (data) => ({
	type: POST_SAVED_DATE_RANGE,
	payload: data,
})

export const postSavedDateRangeSuccess = (data) => ({
	type: POST_SAVED_DATE_RANGE_SUCCESS,
	payload: data,
})

export const postSavedDateRangeFailed = (data) => ({
	type: POST_SAVED_DATE_RANGE_FAIL,
	payload: data,
})

export const postSavedDateRangeClear = () => ({
	type: POST_SAVED_DATE_RANGE_CLEAR,
})

export const deleteSavedDateRange = (data) => ({
	type: DELETE_SAVED_DATE_RANGE,
	payload: data,
})

export const deleteSavedDateRangeSuccess = (data) => ({
	type: DELETE_SAVED_DATE_RANGE_SUCCESS,
	payload: data,
})

export const deleteSavedDateRangeFailed = (data) => ({
	type: DELETE_SAVED_DATE_RANGE_FAIL,
	payload: data,
})

export const checkNameAlreadyExist = (data) => ({
	type: GET_SAVED_DATE_RANGE_NAME_CHECK,
	payload: data,
})

export const checkNameAlreadyExistSuccess = (data) => ({
	type: GET_SAVED_DATE_RANGE_NAME_CHECK_SUCCESS,
	payload: data,
})

export const checkNameAlreadyExistFailed = (data) => ({
	type: GET_SAVED_DATE_RANGE_NAME_CHECK_FAIL,
	payload: data,
})
